<script setup lang="ts">
    import { useTextField } from '@/composables/useTextField';
    import { useFontSelector } from '@/composables/useFontSelector';
    import { dataStore } from '@/commons/DataStore';
    import { useConfigStore } from '@/store/config.store';
    import { onMounted, toRef, watch } from 'vue';
    import { storeToRefs } from 'pinia';
    import type { ITextboxField } from '@/typescript/interfaces/ITextboxField';

    const props = defineProps<{
        field: ITextboxField;
    }>();

    const emit = defineEmits<{
        close: [];
    }>();
    const { currentSide } = storeToRefs(useConfigStore());

    const fabricWorld = dataStore.getFabricWorld(currentSide.value);
    const fieldRef = toRef(() => props.field);
    const { font } = useTextField(fieldRef, fabricWorld);

    const { fonts, selectFont } = useFontSelector(font);

    onMounted(() => {
        if (!font.value) {
            return;
        }
        const selectedElement = document.getElementById(font.value);
        selectedElement?.scrollIntoView();
    });

    watch(font, () => {
        emit('close');
    });
</script>

<template>
    <div>
        <div class="max-h-60 overflow-y-auto">
            <button
                v-for="currentFont in fonts"
                :id="currentFont.fontFace.family"
                :key="currentFont.fontFace.family"
                :class="[
                    font === currentFont.fontFace.family && 'bg-gray-200',
                    'mb-3 w-full appearance-none rounded-md p-2 text-left hover:bg-gray-100',
                ]"
                type="button"
                @click="selectFont(currentFont)"
            >
                <span class="sr-only">{{ $t('select_police') }} {{ currentFont.fontFace.family }}</span>
                <img
                    class="w-full"
                    loading="lazy"
                    :src="currentFont.preview"
                    :alt="currentFont.fontFace.family"
                />
            </button>
        </div>
    </div>
</template>
